module.exports = __webpack_public_path__ + "static/media/Sharp-LQ064X3LW02-Mechanical-Drawing.1f19f99e.gif";